// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"194":"e69ed904","195":"581cb47b","232":"45e8a341","385":"dfc5b6c7","410":"5c35860e","453":"069ab516","542":"75ce8254","556":"aa8c5131","741":"368f35a0","922":"ee8fcad8","938":"170f7687","961":"c9ac44b4"}[chunkId] + ".chunk.js";
};